import {
  ensureAtMentionInText,
  readUsernameFromPayload,
} from '../../utils/usernameFormat';

/** Normalize push notification body so handles always include `@`. */
export function normalizePushNotificationBody(body, payload = {}) {
  const text = typeof body === 'string' ? body.trim() : '';
  if (!text) return '';

  const username = readUsernameFromPayload(payload);
  if (!username) return text;

  return ensureAtMentionInText(text, username);
}
